import { createContext, useContext } from 'react';

import type { CommonFieldDef } from '@/core/dcr/fields/types';
import type { Picklists } from '@/core/dcr/picklists';
import { EntityType } from '@/core/graphql/generated/types';

export type Disclosure = {
	added: readonly string[];
	isAdded: (key: string) => boolean;
	add: (keys: string | readonly string[]) => void;
	takeFlash: (key: string) => boolean;
};

export type DcrFormContextValue = {
	entityType: EntityType;
	countryId: string | undefined;
	picklists: Partial<Picklists>;
	unavailable: ReadonlySet<string>;
	isAvailable: (id: string, def: CommonFieldDef) => boolean;
	isAllowed: (id: string, def: CommonFieldDef) => boolean;
	disclosure: Disclosure;
};

const noop = () => {};

export const DcrFormContext = createContext<DcrFormContextValue>({
	entityType: EntityType.Hcp,
	countryId: undefined,
	picklists: {},
	unavailable: new Set(),
	isAvailable: () => false,
	isAllowed: () => false,
	disclosure: {
		added: [],
		isAdded: () => false,
		add: noop,
		takeFlash: () => false
	}
});

export const useDcrFormContext = () => useContext(DcrFormContext);
